import { BaseApi, ApiResponse } from "../utils/request";

/**
 * 7天充值活动 API 类
 */
export class SevenDayRechargeApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * 领取7天充值活动大奖
   * @param params - 领取参数
   * @param params.taskId - 任务ID (userBonusTaskId)
   * @returns Promise<ApiResponse<any, true>>
   */
  async claimDailyRechargeJackpot(params: {
    id: string;
  }): Promise<ApiResponse<any, true>> {
    return this.post<any, true>("/api/v1/claim_daily_recharge_jackpot", params);
  }
}

export const sevenDayRechargeApi = new SevenDayRechargeApi();

export const claimDailyRechargeJackpot = (params: { id: string }) =>
  sevenDayRechargeApi.claimDailyRechargeJackpot(params);
